export default "__VITE_ASSET__C1SH0zOR__"